import React from "react";

import BookmarkButton from "./BookmarkButton";
import ShareButton from "./ShareButton";
import SupplierMapCard from "./SupplierMapCard";
import {
  AvailabilityBanner,
  PinIcon,
  StarRating,
  SupplierAvatar,
} from "./DetailBits";
import { formatDistanceKm, formatMoney } from "../detailMappers";

const SupplierInfoCard = ({
  name,
  logoUrl,
  rating,
  totalRatings,
  ratingLoading,
  distanceKm,
  online,
  deliveryRadiusKm,
  priceFrom,
  priceFromCurrency,
  addressLine,
  coordinates,
  origin,
  mapsReady,
  notice,
  saved,
  savePending,
  canSave,
  onToggleSave,
  onOpenRatings,
  onOpenLocation,
}) => {
  const distance =
    Number.isFinite(distanceKm) && distanceKm > 0
      ? `${formatDistanceKm(distanceKm)} away`
      : null;

  const place = [addressLine, distance ? `(${distance})` : null]
    .filter(Boolean)
    .join(" ");

  const chips = [
    online ? "Open now" : "Currently closed",
    Number.isFinite(deliveryRadiusKm) && deliveryRadiusKm > 0
      ? `Delivers up to ${Math.round(deliveryRadiusKm)} km`
      : null,
    Number.isFinite(priceFrom) && priceFrom > 0
      ? `From ${formatMoney(priceFrom, priceFromCurrency)}`
      : null,
  ].filter(Boolean);

  return (
    <section className="sy-store">
      <div className="sy-buy-head">
        <SupplierAvatar name={name} logoUrl={logoUrl} size={52} />

        <div className="sy-store-heading">
          <h2 className="sy-buy-title">{name}</h2>

          <div className="sy-store-meta">
            <button
              type="button"
              className="sy-store-rating"
              onClick={onOpenRatings}
              disabled={ratingLoading}
              aria-label={
                totalRatings ? `Read ${totalRatings} reviews` : "Read reviews"
              }
            >
              {ratingLoading ? (
                <span className="sy-muted">Ratings…</span>
              ) : (
                <StarRating rating={rating} total={totalRatings} />
              )}

              <svg viewBox="0 0 20 20" aria-hidden="true">
                <path d="M7.5 4l6 6-6 6" />
              </svg>
            </button>
          </div>

          {place && (
            <button type="button" className="sy-store-place" onClick={onOpenLocation}>
              <PinIcon />

              <span>{place}</span>
            </button>
          )}
        </div>

        <div className="sy-buy-tools">
          {canSave && (
            <BookmarkButton
              saved={saved}
              pending={savePending}
              name={name}
              onToggle={onToggleSave}
            />
          )}

          <ShareButton title={name} />
        </div>
      </div>

      {chips.length > 0 && (
        <ul className="sy-chip-row">
          {chips.map((chip) => (
            <li className="sy-chip" key={chip}>
              {chip}
            </li>
          ))}
        </ul>
      )}

      <AvailabilityBanner notice={notice} />

      <SupplierMapCard
        name={name}
        coordinates={coordinates}
        origin={origin}
        mapsReady={mapsReady}
      />
    </section>
  );
};

export default SupplierInfoCard;
